import React from "react";
import "../../activite/activite.css";

const SingleActivite = () => {
  return (
    <div className="singleActiviteGrid bg-white radius5 px-20 py-20 mt-10">
      <div className="d-flex  gap10 align-items-center">
        <span className="activityPriority bg-green "></span>
        <p className="semibold fs16">En cours</p>
      </div>
      <div className="d-flex flex-column text-center">
        <span className="semibold fs14">11h32</span>
        <span className="semibold fs16">22/12/2024</span>
      </div>
      <div className="bg-red text-center px-20 py-1 radius5 white fs11 medium">
        Élevée
      </div>
      <div className="d-flex flex-column text-center">
        <span className="semibold fs14">Back Office</span>
        <span className="semibold fs16">Accord de prêt</span>
      </div>
      <div className="dotsMenu">
        <button className="border-0 bg-none">
          <img src="./icons/dots-menu.svg" alt="menu" height={40} width={40} />
        </button>
      </div>
    </div>
  );
};

export default SingleActivite;
